import { createContext } from 'react';

export const AppContext = createContext({});
export const AuthContext = createContext({});
export const BookingContext = createContext({});
export const ExperienceBookingContext = createContext({});
export const LanguageContext = createContext({});
